<template>
  <div>
  <Header />
    <LeftNav />
    <main id="page-wrap">
      <!-- <vue-snotify></vue-snotify> -->
      <b-container fluid>
      <UserForm/>
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/layout/AppHeader.vue";
import LeftNav from "@/components/common/layout/AppLeftNav";
import Footer from "@/components/common/layout/AppFooter.vue";
import UserForm from "@/components/user_management/user_form.vue";

export default {
 name: "UserManagement",
  components: {
    Header,
    LeftNav,
    Footer,
    UserForm
  }
}
</script>

<style>

</style>